<template>
  <div class="news-content-container">
    <div class="back-center-panel">
      <div class="back-center" @click="handleJumpPage('OPEN_NEWSCENTER')">
        <div class="back-icon">
          <div class="back-link">返回新闻中心</div>
        </div>
      </div>
    </div>
    <div class="news-content-panel">
      <div class="news-title">第二届腾讯Light·公益创新挑战赛启动，三大赛题聚焦可持续发展社会价值 </div>
      <div class="news-date">2021年12月24日</div>
      <div class="news-content">
        <p><strong>12月23日，“创变者”2021年度腾讯Light论坛在厦门正式举办。</strong>在论坛上，由全国妇联宣传部指导，腾讯公司联合中国儿童中心主办，企鹅伴成长、腾讯华东总部、腾讯SSV创新办学实验室、企鹅爱地球、<strong>腾讯优图实验室</strong>、腾讯云AI、腾讯云微搭承办的第二届腾讯Light·公益创新挑战赛正式启动。</p>
        <p>活动现场公布了<strong>儿童安全保护/教育、素养教育、生物多样性保护/教育三大更具“可持续性”和“科技向善”视野的赛题</strong>，并邀请社会各界参赛者通过腾讯云微搭低代码、腾讯云提供的AI技术，以小程序、H5或PC Web网站的形式打造创新应用，助力解决三大赛题背后的热点问题。</p>
        <p>腾讯高级执行副总裁、云与智慧产业事业群CEO汤道生致辞表示，“服务于人”是人工智能最大的价值，用AI助力更美好的世界，这样的探索存在于实验室里，存在于产业中，也正走向更广阔的社会应用中。</p>
        <p>两年前，腾讯提出“科技向善”的使命愿景，今年又将“推动可持续社会价值创新”写进公司战略。在新一届Light·公益创新挑战赛中，腾讯将继续以开放共建的方式，与更多不同行业的参赛者一同探索人工智能与更广泛的社会价值的结合。</p>
        <p>全国妇联宣传部表示，党和国家高度重视未成年人健康成长，始终坚持儿童优先原则，新周期中国儿童发展纲要明确要求探索在网络空间开展儿童思想道德教育的新途径、新方法，落实政府、企业、学校、家庭、社会保护责任，为儿童提供安全、健康的网络环境。希望腾讯Light·公益创新挑战赛能涌现出更多优秀作品，通过科技的力量，助力培养担当民族复兴大任的时代新人。</p>
        <p>中国儿童中心表示，作为国家级公益性儿童发展、教育和服务机构，中心致力于为儿童提供优质的教育、创设儿童友好的成长环境。以人工智能为核心的互联网信息技术革命，给教育事业发展提供了更多的可能，希望通过此次挑战赛，联合腾讯召集有创造力和责任感的开发者及相关人士，用数字科技助力儿童的教育和成长。</p>
        <p>厦门火炬高新区管委会党工委委员、总工程师邱尖，全国妇联宣传部网络新媒体处处长张玉山，中国儿童中心网络信息中心副主任邵彬，厦门大学南强特聘教授、国家杰出青年科学基金获得者纪荣嵘，腾讯副总裁、腾讯华东总部总经理张立军，腾讯副总裁、腾讯安全管理部总经理朱劲松，腾讯云副总裁、腾讯优图实验室总经理吴运声，腾讯集团市场与公关部副总经理林涛，腾讯SSV创新办学实验室联合负责人梁栋，腾讯云微搭低代码负责人王倩等嘉宾出席论坛并共同见证了本次大赛的启动仪式。</p>
        <div class="image-panel">
          <img class="news-image" src="../img/detail/news5_1.png" />
          <div class="image-caption">启动仪式现场</div>
        </div>
        <div class="news-p-title">01 打造联结科技创新与社会需求的平台&nbsp;&nbsp;Light挑战赛联动社会力量实现公益创变</div>
        <p>首届Light·公益创新挑战赛于2020年12月正式举办，设置「野生动植物保护」、「未成年人网络保护」、「适老化无障碍设计」三大赛题，吸引了663支队伍近3000名参赛者报名参与。</p>
        <p>今年4月，腾讯将可持续社会价值创新纳入公司核心战略，成立可持续社会价值事业部（SSV），在公司内部设立向善实验室群，聚焦基础科学、教育创新、养老科技等公益领域，希望通过技术开放与联合开发，与社会各界共同探索和建设可持续发展的社会价值。</p>
        <p>基于此，今年Light·公益创新挑战赛的赛题设置也将更具“可持续”和“科技向善”视野，聚焦素养教育、儿童安全保护/教育、生物多样性保护/教育三个赛道，为下一代的健康成长保驾护航。</p>
        <p>厦门火炬高新区管委会党工委委员、总工程师邱尖在致辞中表示，2020年腾讯面向全国发起Light计划，今年厦门很高兴成为Light论坛的主办城市。同时，腾讯优图AI创新中心即将落户厦门，未来期待与腾讯进一步深化在产创融合、人才培养和科研课题等方面的合作，推动青年科技人才和研究团队的交流实践。</p>
        <p>本届挑战赛之所以选择在厦门举办，也是基于厦门人工智能方面的发展优势和持续投入。“依托雄厚的产业基础、丰富的创新资源和完整的产业链条，厦门在人工智能领域的人才储备、产业生态、数据规模等方面优势明显。”</p>
        <p>张立军在致辞中表示，近年来腾讯与厦门市政府共同推动AI技术在社会治理、城市管理、公共服务、智慧医疗和智慧教育等领域中落地，已取得了十分亮眼的成果。双方都希望通过本届挑战赛，以“云+AI”的方式，携手各方探索科技公益的落地路径，为社会创造更多可持续发展的社会价值。</p>
        <div class="image-panel">
          <img class="news-image" src="../img/detail/news5_2.png" />
          <div class="image-caption">腾讯副总裁、腾讯华东总部总经理张立军</div>
        </div>
        <p>践行科技向善的过程不会一蹴而就，而是多方参与的“马拉松长跑”。朱劲松表示，举办腾讯Light·公益创新挑战赛的初衷，就是想让这场“马拉松”有更多人来接力和聚力，推动技术与公益的跨界联结。“用户、产业、社会的关系是三位一体，相辅相成的，最终指向的都是满足社会需求，为社会创造价值。</p>
        <p>他认为，“跨界”既是实现用户、产业、社会三位一体的重要路径，也是让科技创新与社会创新齐头并进的加速器，期待和广大技术志愿者、有志于公益的热心人士，一起用科技做出一些美好的改变。</p>
        <div class="image-panel">
          <img class="news-image" src="../img/detail/news5_3.png" />
          <div class="image-caption">腾讯副总裁、腾讯安全管理部总经理朱劲松</div>
        </div>
        <p>一直以来，腾讯都在践行“科技向善”的公司愿景和理念，通过 AI、云计算等技术创造可持续社会价值、输出公益领域的技术解决方案。</p>
        <p>“人工智能在助力产业数字化升级的同时，也对可持续社会价值进行探索。”吴运声认为，为了支持和支撑整个社会的可持续发展，我们应该向公众呼吁，基于长远发展考虑构建不断创新、可持续的科技公益。</p>
        <div class="image-panel">
          <img class="news-image" src="../img/detail/news5_4.png" />
          <div class="image-caption">腾讯云副总裁、腾讯优图实验室总经理吴运声</div>
        </div>
        <p>此外，在首届挑战赛同时斩获一等奖和公益潜力之星奖项的小程序——有光和解忧暖心喵App的开发者胡淼淼，也进行了演讲</p>
        <p>他表示，自正式上线以来，已经有7000多暖心师和100多心理咨询师，在小程序上为未成年人回复近10万封信，而这一切成果都离不开腾讯所开放的技术和资源。“腾讯云、腾讯AI让有光.暖心喵能够正式上线，而QQ、微信则为有光.暖心喵提供了更便捷的用户触达渠道。”胡淼淼表示。</p>
        <div class="image-panel">
          <img class="news-image" src="../img/detail/news5_5.png" />
          <div class="image-caption">有光和解忧暖心喵App的开发者胡淼淼</div>
        </div>
        <div class="news-p-title">02 三大赛题聚焦可持续发展社会价值&nbsp;&nbsp;赛制升级吸引更多参赛者参与科技公益</div>
        <p>活动现场公布了本届Light·公益创新挑战赛的三大赛题——儿童安全保护/教育、素养教育、生物多样性保护/教育，邀请参赛者基于赛题发挥创新思维，运用腾讯云微搭低代码进行开发，并使用最少一项基于腾讯云提供的AI技术，打造相应的创新应用。</p>
        <p>在儿童安全保护/教育赛题中，参赛者会聚焦现实世界和网络空间中未成年人安全问题频发的重点场景，融合AI技术设计出兼具实用性和前瞻性的解决方案，让儿童在现实世界和网络空间中，避免遭受校园霸凌、不良信息等侵害，构建一个孩子能够安全、健康成长的安全世界。</p>
        <p>在素养教育赛题中，参赛者关注发展素养教育过程中遇到问题与挑战，如教学方式单一、教学资源不足等，通过AI技术开发对应的教学工具，通过增强课堂互动、增加教学方式等形式，帮助教师和学生提升教学效率及学习体验，让学生能够在课堂上掌握更多人文、科学等领域的知识和技能，从而达到德智体美育全面发展的目标。</p>
        <p>而生物多样性保护/教育赛题鼓励参赛者充分发挥AI技术的优势，开发出能够激发和培养未成年人对生物多样性保护意识的技术解决方案，从小培养孩子守护生物多样性的观念，从而为国家生物多样性治理体系和治理能力现代化提供助力，进一步促进人与自然和谐共生。</p>
        <p>值得一提的是，本届Light·公益创新挑战赛除了赛题更新、让赛事更加聚焦于创造可持续发展的社会价值外，还打破了作品形式上的限制：参赛者可以自由选择，提交通过腾讯云微搭低代码、腾讯云提供的AI技术打造的小程序、H5或PC Web网站。</p>
        <p>腾讯云微搭低代码负责人王倩表示，打破作品形式上的限制，是希望为参赛者提供更加自由的开发环境，而吸引更多志同道合的技术人员参与到挑战赛中，可以为创造可持续发展社会价值提供更多助力。</p>
        <p>今年，腾讯还发布了技术公益创投计划，面向长期致力于信息无障碍、应急救灾、科技助老、生态环保、文化遗产保护五大领域事业的公益组织等提供具有针对性的资金、技术和资源支持，本届挑战赛所孵化的优秀作品也有机会得到技术公益创投计划的支持。</p>
        <p>作为本届Light·公益创新挑战赛的公益传播大使，艺人俞灏明、陈意涵Estelle也分享了自己对于科技公益和赛题的看法。俞灏明表示对生物多样性赛题最感兴趣，希望有更多爱好公益的有志之士能够参与到此次的挑战赛中，用人工智能为保护生物多样性、保护未成年人提供更多的帮助。</p>
        <p>活动现场，陈意涵Estelle表示其最为关注未成年人安全保护教育的赛题，“网络空间和现实世界中存在很多未知风险和安全隐患，青少年的安全保护意识薄弱，更需要社会的保护。希望通过技术的发展，能够给未成年人营造一个干净爽朗的环境。”</p>
        <p>作为一家科技企业，腾讯致力于发挥自身能力与技术优势，通过探索科技公益的实践路径来更好地回馈社会。</p>
        <p>2019年，腾讯优图实验室首创的“跨年龄人脸识别技术”帮助寻回多名走失儿童，年龄跨度最大的超18年；2020年，腾讯天籁实验室发起“天籁行动”，免费开放腾讯天籁AI音频技术，以提升人工耳蜗降噪效果、打造远程服务等方式改善听障人群的听力体验；腾讯云小微也通过AI知识图谱能力联合动保专家共同打造“神奇雪豹在哪里”小程序，助力提升社会公众对濒危野生动物的保护意识。</p>
        <p>此次发起第二届Light·公益创新挑战赛，腾讯希望通过开放合作，连接社会力量助力科技公益持续发展，呼吁更多技术志愿者通过这一平台，让自己的公益创想变为现实，也希望Light·公益创新挑战赛可以孵化更多创新的科技公益作品，源源不断地向社会输出可持续发展的社会价值。</p>
        <p>点击<a href="http://light.mofyi.com/" target="_blank">阅读原文</a>，即可报名参赛，用AI给世界带来一丝改变。</p>
      </div>
    </div>
  </div>
</template>

<script>
import RouteKey from '@/common/RouteKey';
export default {
  name: 'news5',
  methods: {
    handleJumpPage(url, key) {
      url = RouteKey[url];
      if (key != null) {
        this.$router.transfer(url, { key: key });
        return;
      }
      this.$router.transfer(url);
    }
  }
};
</script>

<style lang="less" scoped>
  @import "./news.less";
</style>


// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News5.vue